export default function IconLinkedin({ className }: { className?: string }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12Z'
        fill='#1275B1'
      />
      <path
        d='M9.46395 7.26911C9.46395 7.97003 8.85638 8.53823 8.10698 8.53823C7.35753 8.53823 6.75 7.97003 6.75 7.26911C6.75 6.5682 7.35753 6 8.10698 6C8.85638 6 9.46395 6.5682 9.46395 7.26911Z'
        fill='white'
      />
      <path d='M6.93555 9.4707H9.25513V16.4996H6.93555V9.4707Z' fill='white' />
      <path
        d='M12.9895 9.47108H10.6699V16.5H12.9895C12.9895 16.5 12.9895 14.2872 12.9895 12.9037C12.9895 12.0732 13.2731 11.2391 14.4045 11.2391C15.6831 11.2391 15.6754 12.3259 15.6694 13.1678C15.6616 14.2683 15.6802 15.3914 15.6802 16.5H17.9998V12.7903C17.9802 10.4216 17.3629 9.33008 15.3323 9.33008C14.1264 9.33008 13.3788 9.87758 12.9895 10.3729V9.47108Z'
        fill='white'
      />
    </svg>
  )
}
